import './MovingText.css';
export default function MovingText(){
    return(
        <div className="marquee">
        {/* <span className='main'>HaHu Bingo. ሀሁ ቢንጎ</span> */}
    </div>
    );
}